// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"8b3d2a36","504":"9462f4fa"}[chunkId] + ".chunk.css";
};